<script lang="ts">
    import ProjectTemplateDownloadPage from '@Projects/Pages/ProjectTemplateDownloadPage'
    export default ProjectTemplateDownloadPage
</script>

<template>
    <div>
        <div class="container" v-if="rm">
            <div v-if="IsDownloading">
                <h1>Downloading template...</h1>
                <h3>Depending on the project's size it may take from a few seconds to a few minutes.</h3>
            </div>

            <div v-else class="row" >
                <div class="col-lg-8 col-md-10 col-sm-12">

                    <h3 class="my-5">Please select a workspace to download a template:</h3>

                    <table class="table table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Workspace</th>
                                <th style="width: 100px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="w in rm.Workspaces" :key="w.Id">
                                <td>{{w.Name}}</td>
                                <td>
                                    <button class="btn btn-primary text-white" @click="handleDownloadProjectTemplateCommand(w.Id)">Download</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>